import { DataModel, ListDataModel, ListQueryModel } from "../../base";
import { provideReact } from "../../react/index.js";
import { classes } from "polytype";
import { config } from "../../config/config";
import type { CitiesListItemData, CitiesListQueryData } from "./types";

export const LOCATION_DACH_ZIP_CODE = "DACH-RAUM";

export class City {
  public static query(query: CitiesListQueryData) {
    return new CityListQuery(query);
  }
}

class CityCommon extends classes(DataModel<CitiesListItemData>) {
  public readonly city: string;
  public readonly zipCode: string;
  public readonly country: string;

  public constructor(data: CitiesListItemData) {
    super([data]);

    this.city = data.city;
    this.zipCode = data.postCode;
    this.country = data.country;
  }
}

export class CityListItem extends classes(
  CityCommon,
  DataModel<CitiesListItemData>,
) {
  public constructor(data: CitiesListItemData) {
    super([data], [data]);
  }
}

export class CityListQuery extends ListQueryModel<CitiesListQueryData> {
  public constructor(query: CitiesListQueryData) {
    super(query);
  }

  public refine(query: CitiesListQueryData) {
    return new CityListQuery({ ...this.query, ...query });
  }

  public execute = provideReact(async () => {
    const { items, totalCount } = await config.behaviors.city.list(this.query);
    return new CityList(
      this.query,
      items.map((item) => new CityListItem(item)),
      totalCount,
    );
  });
}

export class CityList extends classes(
  CityListQuery,
  ListDataModel<CityListItem>,
) {
  public constructor(
    query: CitiesListQueryData,
    cities: CityListItem[],
    totalCount: number,
  ) {
    super([query], [cities, totalCount]);
  }
}
